export const parsePermission = (datum) => {
    if (!datum) return
    return {
        id: datum.get('id'),
        canView: datum.get('canView'),
        canEdit: datum.get('canEdit'),
        isAction: datum.get('isAction'),
    }
}
